import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@environment/environment';
import { RuntimeConfigService } from '@services/runtime-config/runtime-config.service';

export const basicAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const basicAuth = inject(RuntimeConfigService).basicAuth;
  if (environment.production || !basicAuth) {
    return next(req);
  }

  const credentials = btoa(`${basicAuth.user}:${basicAuth.access}`);
  const authReq = req.clone({
    setHeaders: {
      Authorization: `Basic ${credentials}`
    }
  });
  return next(authReq);
};
